const PESSOA_TIPO = {
    IF: { id: 1, descricao: 'Instituição Financeira' },
    PRV: { id: 4, descricao: 'Previdência' },
    ETM: { id: 16, descricao: 'Emissor' },
    GES: { id: 64, descricao: 'Gestor' },
    ADM: { id: 256, descricao: 'Administrador' },
    BAL: { id: 2048, descricao: 'Balanço' },
    PUB: { id: 4096, descricao: 'Pública' },
    AI: { id: 262144, descricao: 'Acessor' },
    EST: { id: 16777216, descricao: 'Estrangeira' },
    FIS: { id: 268435456, descricao: 'Pessoa Física' },
    OUT: { id: 1073741824, descricao: 'Outros' }
};

module.exports = PESSOA_TIPO;
